import { getRovoChatBridgeProduct } from './getRovoChatBridgeProduct';
import { type ConversationAssistantUIModes } from './types';

export type RovoChatXpcContextValues = {
	bridgeProduct: string;
	xpcProduct: string;
	xpcSubProduct: string | undefined;
};

export const getRovoChatXpcContextValues = ({
	mode,
	isFullScreen,
	xpcProduct,
	xpcSubProduct,
	productKey,
}: {
	mode: ConversationAssistantUIModes | undefined;
	isFullScreen: boolean | undefined;
	xpcProduct: string | undefined;
	xpcSubProduct: string | undefined;
	productKey: string;
}): RovoChatXpcContextValues => ({
	bridgeProduct: getRovoChatBridgeProduct(mode, isFullScreen),
	xpcProduct: xpcProduct || productKey,
	xpcSubProduct,
});
